import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Sidebar } from '../../layout/components';
import { SidebarList } from '../../layout/styles';

function SettingsSidebar(props, { __ }) {
  const { Title } = Sidebar.Section;

  return (
    <Sidebar>
      <Sidebar.Section>
        <Title>{__('settings')}</Title>
        <SidebarList>
          <li>
            <NavLink activeClassName="active" to="/settings/Providers">
              {__('Providers')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/SIPExtensions">
              {__('SIP Extensions')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/Phonenumbers">
              {__('Phone Numbers')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/CSAT">
              {__('CSAT')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/DNC">
              {__('DNC')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/Tag">
              {__('Tag')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/break">
              {__('Break')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/sounds">
              {__('Sounds')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/Country">
              {__('Country')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/User">
              {__('User')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/Contact-List-Private">
              {__('Contact')}
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/settings/Queue">
              {__('Queue')}
            </NavLink>
          </li>
        </SidebarList>
      </Sidebar.Section>
    </Sidebar>
  );
}

SettingsSidebar.contextTypes = {
  __: PropTypes.func
};

export default SettingsSidebar;



// WEBPACK FOOTER //
// src/modules/screens/settings/sidebar.js